import React from "react";
import MUIDataTable from "mui-datatables";
import { CircularProgress, Box, Button } from "@mui/material";
import './App.css';
import { utils, write } from "xlsx";
import { saveAs } from 'file-saver';
import { adaptV4Theme, createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import MalzemeListesiOnizleme from "./MalzemeListesiOnizleme";
import moment from "moment";
import { api } from "./api/client";
import { enhanceColumns, withTableOptions } from "./utils/tableDisplay";

const AYLAR = ['Oca','Şub','Mar','Nis','May','Haz','Tem','Ağu','Eyl','Eki','Kas','Ara'];

const teklifTipiLabels = {
    teklif: "Teklif",
    yedek_parca: "Yedek Parça",
    sozlesme: "Bakım Sözleşmesi",
    agir_bakim: "Ağır Bakım",
    agir_tamir: "Ağır Tamir",
    revizyon_guncelleme: "Revizyon-Güncelleme",
};

const teklifTipiLabel = (value) => teklifTipiLabels[value] || value || "";

function yillar() {
    const now = new Date().getFullYear();
    return Array.from({ length: now - 2022 + 1 }, (_, i) => 2022 + i);
}

class TeklifSatisRaporuDetay extends React.Component {
    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const temsilci = params.get("temsilci") || "";
        const teklifTipi = params.get("teklif_tipi") || "";
        const now = new Date();
        const yil = now.getFullYear();
        const ay  = now.getMonth() + 1; // 1-12

        this.state = {
            veriler: [],
            yukleniyor: true,
            temsilci,
            baslangicYil: yil,
            baslangicAy:  1,
            bitisYil:     yil,
            bitisAy:      ay,
            teklifTipi,
            mal:          0,
            hizmet:       0,
            sortOrder: { name: "sevk_tarihi", direction: "desc" },
        };
    }

    componentDidMount() {
        this.veriGetir();
    }

    pad = (n) => String(n).padStart(2, '0');

    veriGetir = () => {
        this.setState({ yukleniyor: true });
        const { baslangicYil, baslangicAy, bitisYil, bitisAy, temsilci, teklifTipi } = this.state;
        const baslangic = `${baslangicYil}-${this.pad(baslangicAy)}`;
        const bitis     = `${bitisYil}-${this.pad(bitisAy)}`;
        const teklifTipiParam = teklifTipi ? `&teklif_tipi=${encodeURIComponent(teklifTipi)}` : "";

        api
            .get(`/raporlar/teklif-satis/detay`, {
                params: {
                    baslangic,
                    bitis,
                    temsilci: temsilci || undefined,
                    teklif_tipi: teklifTipi || undefined,
                },
            })
            .then(res => {
                try {
                    const liste = Array.isArray(res.data.liste) ? res.data.liste : [];
                    const temiz = liste
                        .filter(d => d && typeof d === "object")
                        .map(d => ({
                            teklif_no:     d?.teklif_no     ?? "",
                            teklif_tarihi: d?.teklif_tarihi ?? "",
                            teslim_tarihi: d?.teslim_tarihi ?? "",
                            sevk_tarihi:   d?.sevk_tarihi   ?? "",
                            musteri:       d?.musteri       ?? "",
                            lokasyon:      d?.lokasyon      ?? "",
                            makine:        d?.makine        ?? "",
                            teklif_tipi:   d?.teklif_tipi   ?? "",
                            uyf_no:        d?.uyf_no        ?? "",
                            seri_no:       d?.seri_no       ?? "",
                            temsilci:      d?.temsilci      ?? "",
                            urun_tipi:     d?.urun_tipi ? d.urun_tipi.toUpperCase().replace('SSH_HM','SSH HM') : "",
                            mal_hizmet:    d?.mal_hizmet    ?? "",
                            urun_adi:      d?.urun_adi      ?? "",
                            aciklama:      d?.aciklama      ?? "",
                            adet:          d?.adet          ? parseInt(d.adet) : 0,
                            fiyat_euro:    d?.fiyat_euro    ? parseFloat(d.fiyat_euro) : 0,
                        }));
                    const mal     = res.data.toplamlar?.mal     ?? 0;
                    const hizmet  = res.data.toplamlar?.hizmet  ?? 0;
                    this.setState({ veriler: temiz, yukleniyor: false, mal, hizmet });
                } catch (err) {
                    console.error("Veri map hatası:", err);
                    this.setState({ veriler: [], yukleniyor: false });
                }
            })
            .catch(err => {
                console.error("Veri alınamadı:", err.message);
                this.setState({ yukleniyor: false });
            });
    };

    render() {
        const { baslangicYil, baslangicAy, bitisYil, bitisAy, teklifTipi } = this.state;

        const options = {
            sortOrder: this.state.sortOrder,
            onTableChange: (action, tableState) => {
                if (action !== "sort") return;
                const sort = tableState.sortOrder || {};
                if (!sort.name || !sort.direction) return;
                this.setState({ sortOrder: { name: sort.name, direction: sort.direction } });
            },
            filter: true,
            selectableRows: 'none',
            filterType: 'multiselect',
            responsive: "vertical",
            rowsPerPage: 200,
            fixedHeader: true,
            tableBodyHeight: '80%',
            print: false,
            download: true,
            searchOpen: false,
            draggableColumns: { enabled: true, transitionTime: 400 },
            downloadOptions: {
                filterOptions: { useDisplayedColumnsOnly: true, useDisplayedRowsOnly: true }
            },
            textLabels: {
                body: {
                    noMatch: "Bu tabloda hiç bir veri yok",
                    toolTip: "Sırala",
                    columnHeaderTooltip: column => `${column.label} için sırala`,
                },
                pagination: { next: "İleri", previous: "Geri", rowsPerPage: "Sayfadaki satır sayısı:", displayRows: "/" },
                toolbar: { search: "Ara", downloadCsv: "XLSX İndir", print: "Çıktı Al", viewColumns: "Sütunları Göster", filterTable: "Tabloyu Süz" },
                filter: { all: "Tümünü Göster", title: "Filtreler", reset: "Sıfırla" },
                viewColumns: { title: "Sütunları Göster", titleAria: "Sütunları Göster/Gizle" },
            },
            onDownload: (buildHead, buildBody, columns, values) => {
                const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                const json = values.reduce((result, val) => {
                    const temp = {};
                    val.data.forEach((v, idx) => { temp[columns[idx].label] = v; });
                    result.push(temp);
                    return result;
                }, []);
                const ws = utils.json_to_sheet(json);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
                saveAs(new Blob([excelBuffer], { type: fileType }), `Teklif_Satis_Detay_${baslangicYil}.xlsx`);
                return false;
            },
        };

        const myTheme = createTheme(adaptV4Theme({
            overrides: {
                MUIDataTableHead: { root: { lineHeight: 0.5, maxHeight: "10px", padding: 0 } },
                MUIDataTableBodyRow: {
                    root: {
                        '&:nth-child(odd)':  { backgroundColor: '#eee' },
                        '&:nth-child(even)': { backgroundColor: '#fff' },
                        lineHeight: 1, padding: 1,
                    },
                },
                MuiTableCell: {
                    head: { backgroundColor: "#e59e53 !important", fontWeight: "bold", padding: 5 },
                    root: { lineHeight: 1 },
                },
            },
        }));

        function kisaltMusteriAdi(ad) {
            if (!ad) return '';
            return ad.trim().split(" ").slice(0, 2).join(" ");
        }

        const kolonlar = [
            {
                name: "teklif_no",
                label: "Teklif No",
                options: {
                    filter: false,
                    customBodyRender: (value, meta) => {
                        const record = this.state.veriler[meta.currentTableData[meta.rowIndex].index];
                        return value
                            ? <MalzemeListesiOnizleme key={meta.rowIndex} teklifNo={value} teklifDili={""} teklifTarihi={record.teklif_tarihi} />
                            : null;
                    },
                }
            },
            {
                name: "teklif_tarihi",
                label: "Teklif Tarihi",
                options: { filter: false, customBodyRender: (v) => v ? moment(new Date(v)).format('DD/MM/YYYY') : '' }
            },
            {
                name: "teslim_tarihi",
                label: "Teslim Tarihi",
                options: { filter: false, customBodyRender: (v) => v ? moment(new Date(v)).format('DD/MM/YYYY') : '' }
            },
            {
                name: "sevk_tarihi",
                label: "Sevk Tarihi",
                options: { filter: false, customBodyRender: (v) => v ? moment(new Date(v)).format('DD/MM/YYYY') : '' }
            },
            {
                name: "musteri",
                label: "Müşteri",
                options: { filter: true, filterOptions: { fullWidth: true }, customBodyRender: (v) => kisaltMusteriAdi(v) }
            },
            { name: "lokasyon", label: "Lokasyon", options: { filter: false } },
            { name: "makine", label: "Makine", options: { filter: false, sort: false } },
            {
                name: "teklif_tipi",
                label: "Teklif Tipi",
                options: {
                    filter: true,
                    filterOptions: { fullWidth: true },
                    customBodyRender: (v) => teklifTipiLabel(v),
                    sort: false
                }
            },
            { name: "uyf_no",   label: "UYF No",   options: { filter: true, filterOptions: { fullWidth: true }, sort: false } },
            { name: "seri_no",  label: "Seri No",   options: { filter: true, filterOptions: { fullWidth: true }, sort: false } },
            { name: "temsilci", label: "Temsilci",  options: { filter: true, filterOptions: { fullWidth: true }, sort: false } },
            { name: "urun_tipi",  label: "Ürün Tipi",  options: { filter: true, filterOptions: { fullWidth: true }, sort: false } },
            { name: "urun_adi",   label: "Ürün Adı",   options: { filter: false } },
            { name: "mal_hizmet",   label: "Mal/Hizmet",   options: { filter: false } },
            { name: "aciklama", label: "Açıklama",  options: { filter: false } },
            { name: "adet",     label: "Adet",      options: { filter: false } },
            {
                name: "fiyat_euro",
                label: "Fiyat (€)",
                options: {
                    filter: false,
                    customBodyRender: (v) => v?.toLocaleString("tr-TR", { minimumFractionDigits: 2 }),
                }
            },
        ];

        const { mal, hizmet } = this.state;
        const toplam = mal + hizmet;

        const selectSx = { minWidth: 90 };

        return (
            <Box sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 2 }}>
                    {/* Başlangıç */}
                    <FormControl size="small" sx={selectSx}>
                        <InputLabel>Başlangıç Yıl</InputLabel>
                        <Select value={baslangicYil} label="Başlangıç Yıl"
                            onChange={e => this.setState({ baslangicYil: e.target.value })}>
                            {yillar().map(y => <MenuItem key={y} value={y}>{y}</MenuItem>)}
                        </Select>
                    </FormControl>
                    <FormControl size="small" sx={selectSx}>
                        <InputLabel>Ay</InputLabel>
                        <Select value={baslangicAy} label="Ay"
                            onChange={e => this.setState({ baslangicAy: e.target.value })}>
                            {AYLAR.map((ad, i) => <MenuItem key={i+1} value={i+1}>{ad}</MenuItem>)}
                        </Select>
                    </FormControl>

                    <Box sx={{ px: 1, color: '#888' }}>—</Box>

                    {/* Bitiş */}
                    <FormControl size="small" sx={selectSx}>
                        <InputLabel>Bitiş Yıl</InputLabel>
                        <Select value={bitisYil} label="Bitiş Yıl"
                            onChange={e => this.setState({ bitisYil: e.target.value })}>
                            {yillar().map(y => <MenuItem key={y} value={y}>{y}</MenuItem>)}
                        </Select>
                    </FormControl>
                    <FormControl size="small" sx={selectSx}>
                        <InputLabel>Ay</InputLabel>
                        <Select value={bitisAy} label="Ay"
                            onChange={e => this.setState({ bitisAy: e.target.value })}>
                            {AYLAR.map((ad, i) => <MenuItem key={i+1} value={i+1}>{ad}</MenuItem>)}
                        </Select>
                    </FormControl>

                    <FormControl size="small" sx={{ minWidth: 140 }}>
                        <InputLabel>Teklif Tipi</InputLabel>
                        <Select
                            value={teklifTipi}
                            label="Teklif Tipi"
                            onChange={e => this.setState({ teklifTipi: e.target.value })}
                        >
                            <MenuItem value="">Tümü</MenuItem>
                            <MenuItem value="teklif">Teklif</MenuItem>
                            <MenuItem value="yedek_parca">Yedek Parça</MenuItem>
                            <MenuItem value="sozlesme">Bakım Sözleşmesi</MenuItem>
                            <MenuItem value="agir_bakim">Ağır Bakım</MenuItem>
                            <MenuItem value="agir_tamir">Ağır Tamir</MenuItem>
                            <MenuItem value="revizyon_guncelleme">Revizyon-Güncelleme</MenuItem>
                        </Select>
                    </FormControl>

                    <Button variant="contained" size="small" onClick={this.veriGetir}
                        sx={{ backgroundColor: '#e59e53', '&:hover': { backgroundColor: '#c87d30' } }}>
                        Filtrele
                    </Button>

                    <Box sx={{ ml: 2 }}>
                        <strong style={{ color: '#f60' }}>Ürün: </strong>
                        {mal.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} € &nbsp;|&nbsp;
                        <strong style={{ color: '#f60' }}>Hizmet: </strong>
                        {hizmet.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} € &nbsp;|&nbsp;
                        <strong style={{ color: '#f60' }}>Toplam: </strong>
                        {toplam.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} €
                    </Box>
                </Box>

                {this.state.yukleniyor ? (
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <ThemeProvider theme={myTheme}>
                        <MUIDataTable
                            title={`Teklif Satış Detay Raporu — ${AYLAR[baslangicAy-1]} ${baslangicYil} / ${AYLAR[bitisAy-1]} ${bitisYil}${this.state.temsilci ? ' | ' + this.state.temsilci : ''}`}
                            data={this.state.veriler}
                            columns={enhanceColumns(kolonlar)}
                            options={withTableOptions(options)}
                        />
                    </ThemeProvider>
                )}
            </Box>
        );
    }
}

export default TeklifSatisRaporuDetay;
